import { BlueButton } from 'pages/NotifyEvent/styles'
import React from 'react'
import { IoCloseSharp } from 'react-icons/io5'


interface IDataLondonProtocolInfoModal {
  close: () => void
}
export default function DataLondonProtocolInfoModal({ close }: IDataLondonProtocolInfoModal) {
  return (
    <div data-testid="test-anonymous-modal" className='md:text-center text-left md:px-10 md:py-10 md:w-[767px]'>
      <div className='flex items-between'>
        <div className='text-start flex w-full'>
          <p className='text-lg font-semibold text-yellow'>Fonte de dados e métodos:</p>
        </div>
        <div
          className='ml-auto cursor-pointer'
          data-testid="test-close-info-modal"
          onClick={close}
        >
          <IoCloseSharp
            className="text-blueTheme h-8 w-8 p-1 cursor-pointer "
          />
        </div>
      </div>
      <p className='text-darkGray text-start text-xs'>Exemplos</p>
      <p className="text-darkGray mt-4 text-start text-sm before:content-['•'] before:mr-2 ">
        Coleta de informações - incluindo conversas com pacientes e familiares/cuidadores e profissionais envolvidos de forma direta ou por terem uma função importante na área clínica, por exemplo, um papel de liderança.
      </p>
      <p className="text-darkGray mt-4 text-start text-sm before:content-['•'] before:mr-2 ">
        Informações coletadas de anotações sobre o paciente e outras documentações pertinentes, por exemplo, e-mails com membros relevantes da equipe.
      </p>
      <p className="text-darkGray mt-4 text-start text-sm before:content-['•'] before:mr-2 ">
        Quaisquer métodos usados para fornecer insights adicionais, por exemplo, o desenho de um mapa do processo, o uso de uma simulação ou observações estruturadas no local de trabalho.
      </p>
      <p className="text-darkGray mt-4 text-start text-sm before:content-['•'] before:mr-2 ">
        Observações estruturadas dos ambientes clínicos.
      </p>
    </div>
  )
}
